import { render, staticRenderFns } from "./DetailDeviceHistorical.vue?vue&type=template&id=322e50d6&"
import script from "./DetailDeviceHistorical.vue?vue&type=script&lang=js&"
export * from "./DetailDeviceHistorical.vue?vue&type=script&lang=js&"
import style0 from "./DetailDeviceHistorical.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports